import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.11.2_@unocss+reset@0.59.2_eslint@8.57.0_floating-vue@5.2.2_rollup@4.14.2_sass@1.75.0_t_iqrgvlndu7w6ifm3qbqyubkvma/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}